import { useGuestPayorOnboarding, useGuestPayorPaymentRequestDetails } from '@melio/ar-domain';
import { forwardRef } from '@melio/platform-utils';
import React from 'react';

import { CardHolderDetailsFormFields } from '../types';
import { useAddCardFundingSource } from './hooks';
import { AddCardFormScreen } from './screens';

type AddCardFundingSourceActivityProps = {
  onDone: (id: string) => void;
  paymentRequestLink: string;
};

export const V2AddCardFundingSourceActivity = forwardRef<AddCardFundingSourceActivityProps>(
  ({ paymentRequestLink, onDone }, ref) => {
    const { data: paymentRequestDetails, isLoading: isLoadingPaymentRequestLink } = useGuestPayorPaymentRequestDetails({
      paymentRequestLink,
    });
    const { onboarding, isLoading: isLoadingOnBoarding } = useGuestPayorOnboarding();
    const { isCreating, addCard } = useAddCardFundingSource({
      onAddCardSuccess: (id: string) => onDone(id),
    });

    const handleOnSubmit = async (formValues: CardHolderDetailsFormFields) => {
      await onboarding({
        email: formValues.email,
        paymentRequestLink,
      });
      await addCard(formValues);
    };

    return (
      <AddCardFormScreen
        onSubmit={handleOnSubmit}
        isSaving={isLoadingOnBoarding || isLoadingPaymentRequestLink || isCreating}
        amount={paymentRequestDetails?.invoice.totalAmount || 0}
        ref={ref}
      />
    );
  }
);
V2AddCardFundingSourceActivity.displayName = 'V2AddCardFundingSourceActivity';
